import { getDispenseUnits } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type { StandardDispenseUnitTypeT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchDispenseUnits(
  signal?: AbortSignal
): Promise<StandardDispenseUnitTypeT[]> {
  const config = await createLotusRequestConfig({ signal });
  const response = await getDispenseUnits(config);
  return lotusHealthZod.getDispenseUnitsResponse.parse(
    response.data
  ) as StandardDispenseUnitTypeT[];
}
